import PaidRoundedIcon from "@mui/icons-material/PaidRounded";
import ElectricBoltRoundedIcon from "@mui/icons-material/ElectricBoltRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import WaterDropRoundedIcon from "@mui/icons-material/WaterDropRounded";
import KitchenRoundedIcon from "@mui/icons-material/KitchenRounded";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import CreditScoreRoundedIcon from "@mui/icons-material/CreditScoreRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import PermContactCalendarRoundedIcon from "@mui/icons-material/PermContactCalendarRounded";
import FavoriteIcon from "@mui/icons-material/Favorite";
import imgBienestar from "../img/bienestar.png";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";

const iconSize = 35;
const imgWidth = 50;
const imgHeight = 50;
const tramites = [
  {
    id: 10,
    title: "Red Bienestar Cooperativo",
    icon: (
      <img
        src={imgBienestar}
        alt="Bienestar Cooperativa"
        style={{ width: imgWidth, height: imgHeight, objectFit: "contain" }}
      />
    ),
    navegator: "/tramites/bienestar-cooperativo",
    color: "#93C01F",
  },
  {
    id: 2,
    title: "Mis Servicios",
    icon: (
      <MiscellaneousServicesIcon
        style={{ fontSize: iconSize, color: "#34495E" }}
      />
    ),
    navegator: "/tramites/servicios",
    color: "#34495E",
  },
  {
    id: 1,
    title: "Pagá/Imprimí tus Facturas.",
    desc: "",
    icon: <PaidRoundedIcon style={{ fontSize: iconSize, color: "#229954" }} />,
    navegator: "https://cooppagos.coop5.com.ar/",
    color: "#229954",
  },
  {
    id: 3,
    title: "Conexión de Servicios TIC",
    icon: <WifiRoundedIcon style={{ fontSize: iconSize, color: "#7FB3D5" }} />,
    navegator: "https://oficinavirtual.coop5.com.ar/login",
    color: "#7FB3D5",
  },
  {
    id: 4,
    title: "Conexión de Energía",
    desc: "",
    icon: (
      <ElectricBoltRoundedIcon
        style={{ fontSize: iconSize, color: "#F39C12" }}
      />
    ),
    // navegator: "/conexion",
    navegator:"https://oficinavirtual.coop5.com.ar/login",
    color: "#F39C12",
  },

  {
    id: 5,
    title: "Conexión de Agua Potable",
    desc: "",
    icon: (
      <WaterDropRoundedIcon style={{ fontSize: iconSize, color: "#3498DB" }} />
    ),
    // navegator: "/conexionAgua",
    navegator: "https://oficinavirtual.coop5.com.ar/login",
    color: "#3498DB",
  },
  {
    id: 6,
    title: "Curriculum Vitae",
    desc: "",
    icon: (
      <AssignmentIndRoundedIcon
        style={{ fontSize: iconSize, color: "#8E44AD" }}
      />
    ),
    navegator: "/curriculumvitae",
    color: "#8E44AD",
  },

  {
    id: 7,
    title: "Declará tus artefactos",
    desc: "",
    icon: (
      <KitchenRoundedIcon style={{ fontSize: iconSize, color: "#1ABC9C" }} />
    ),
    navegator: "/tramites/electrodomesticos",
    color: "#1ABC9C",
  },

  {
    id: 8,
    title: "Adhesion / Baja al débito Automático",
    desc: "",
    icon: (
      <CreditScoreRoundedIcon
        style={{ fontSize: iconSize, color: "#CB4335" }}
      />
    ),
    navegator: "/tramites/debito",
    color: "#CB4335",
  },
  {
    id: 9,
    title: "Mis datos de Contacto",
    desc: "",
    icon: (
      <PermContactCalendarRoundedIcon
        style={{ fontSize: iconSize, color: "#AF601A" }}
      />
    ),
    navegator: "/tramites/actualizar-email",
    color: "#AF601A",
  },
];

export { tramites };
